import React from 'react'
import parse from 'html-react-parser'

const Table = ({ table }) => {
  const text1 = table.table_body[0][0].text || ''
  const number1 = table.table_body[0][1].text || ''

  const text2 = table.table_body[1][0].text || ''
  const number2 = table.table_body[1][1].text || ''

  const text3 = table.table_body[2][0].text || ''
  const number3 = table.table_body[2][1].text || ''

  return (
    <div className='stats-table'>
      <div className='box'>
        <p className='number'>{parse(number1)}</p>
        <p className='text'>{parse(text1)}</p>
      </div>
      <div className='box'>
        <p className='number'>{parse(number2)}</p>
        <p className='text'>{parse(text2)}</p>
      </div>
      <div className='box'>
        <p className='number'>{parse(number3)}</p>
        <p className='text'>{parse(text3)}</p>
      </div>
    </div>
  )
}

export default Table
